import { ActivityEventDto } from '../../../shared/modules/activity/dtos/activity-event.dto';
import { VehicleRoadTaxActivityEventHydration } from './vehicle-road-tax-activity-event-hydration.dto';

/**
 * A vehicle road tax activity event with hydrated related records.
 */
export class VehicleRoadTaxActivityEventDto extends ActivityEventDto {
  hydrated?: VehicleRoadTaxActivityEventHydration;
}
